import { useState } from "react";
import Papa from "papaparse";
import { useDispatch } from "react-redux";
import errorToast from "./error-toast";
const useCsvUpload = (actionType, expectedHeaders) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const onError = (data) => {
    errorToast(data?.data?.message);
    setLoading(false);
  };

  const handleFileUpload = async (event, onSuccess) => {
    const file = event?.target?.files?.[0];
    if (!file) return;
    event.target.value = "";
    setLoading(true);
    try {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: async (results) => {
          const parsedData = results.data;
          if (!parsedData || parsedData.length === 0 || !parsedData[0]) {
            errorToast(
              "Error: The CSV file is empty or contains no valid records."
            );
            setLoading(false);
            return;
          }
          const fileHeaders = Object.keys(parsedData[0]);
          const isValidTemplate = expectedHeaders.every((header) =>
            fileHeaders.includes(header)
          );
          if (!isValidTemplate) {
            errorToast(
              "Error: CSV template does not match the required format."
            );
            setLoading(false);
            return;
          }
          dispatch(
            actionType(
              parsedData,
              (data) => {
                setLoading(false);
                onSuccess(data);
              },
              onError
            )
          );
        },
      });
    } catch (error) {
      errorToast("Error: Failed to process CSV file.");
      //   onError && onError(error);
      setLoading(false);
    }
  };
  return { handleFileUpload, loading };
};
export default useCsvUpload;
